import { FunctionComponent } from 'react';

export type Props = {};

const ShowcaseProductquality: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <div className="showcase">
      <h2>Produkt- & Qualitätsmanagement</h2>
      <h3>"Exzellenz in jedem Produkt!"</h3>

      <h2>Einleitung</h2>
      <p>
        Qualität ist der Schlüssel zu langfristigem Markterfolg. Um Produkte kontinuierlich zu
        verbessern und höchste Standards zu gewährleisten, brauchst du präzise Einblicke in
        Qualitätsdaten. PS IMAGO PRO hilft dir, Optimierungspotenziale in der Entwicklungsphase und
        beim Markteintritt frühzeitig zu erkennen und umzusetzen.
      </p>

      <h2>Herausforderungen im Produkt- & Qualitätsmanagement</h2>
      <ul>
        <li>
          <strong>Früherkennung von Qualitätsmängeln:</strong> Potenzielle Schwachstellen müssen
          rechtzeitig erkannt werden, um Fehlerkosten zu minimieren.
        </li>
        <li>
          <strong>Datenbasierte Entscheidungsfindung:</strong> Umfassende Analysen sind notwendig,
          um qualitätsrelevante Trends und Abweichungen zu identifizieren.
        </li>
        <li>
          <strong>Effizienzsteigerung:</strong> Produktions- und Entwicklungsprozesse müssen
          kontinuierlich optimiert werden.
        </li>
        <li>
          <strong>Einhaltung von Standards:</strong> Produkte müssen den höchsten regulatorischen
          und marktspezifischen Anforderungen entsprechen.
        </li>
      </ul>

      <h2>Die Lösung: PS IMAGO PRO</h2>
      <p>
        PS IMAGO PRO unterstützt dich bei der Analyse und Optimierung von Qualitätsprozessen durch:
      </p>
      <ul>
        <li>
          <strong>Automatisierte Qualitätskontrolle:</strong> Identifiziere Abweichungen und Mängel
          frühzeitig.
        </li>
        <li>
          <strong>Umfassende Datenanalysen:</strong> Analysiere Produktqualität über verschiedene
          Entwicklungs- und Produktionsphasen hinweg.
        </li>
        <li>
          <strong>Visuelle Dashboards:</strong> Klare Visualisierungen ermöglichen fundierte
          Entscheidungen.
        </li>
        <li>
          <strong>Echtzeit-Überwachung:</strong> Behalte alle Qualitätskennzahlen im Blick und
          optimiere deine Prozesse sofort.
        </li>
      </ul>

      <h2>Praxisbeispiel: Qualitätsmanagement mit PS IMAGO PRO</h2>
      <p>
        Ein führender Hersteller nutzt PS IMAGO PRO, um seine Produktionsprozesse zu optimieren.
        Durch die detaillierte Analyse von Qualitätsdaten konnten Fehlerquoten signifikant gesenkt
        und Produkte schneller zur Marktreife gebracht werden.
      </p>

      <h2>Fazit: Höchste Qualität durch datenbasierte Optimierung</h2>
      <p>
        Mit PS IMAGO PRO hebst du dein Qualitätsmanagement auf das nächste Level. Dank präziser
        Datenanalysen, Echtzeit-Überwachung und automatisierter Kontrolle stellst du sicher, dass
        deine Produkte höchsten Standards entsprechen und am Markt erfolgreich sind.
      </p>

      <p>
        <strong>
          Setze auf exzellente Qualität! <a href="/de/contact">Kontaktiere uns</a> für eine
          individuelle Beratung.
        </strong>
      </p>
    </div>
  );
};

export default ShowcaseProductquality;
